<cec-dialog 
  [headerText]="'Confirmation' | translate"
  (onButtonClicked)="onClickButton($event)"
>
  <div class="static-message">
    <mat-icon class="warning-icon">error_outline</mat-icon>
    {{ 'ConfirmationMessage' | translate }}
  </div>
  <h2 class="confirmation-message">
    {{ messageKey | translate }}
  </h2>
</cec-dialog>
